export default __webpack_public_path__ + "static/media/silver.d5b23b93.png";